module.exports = __webpack_public_path__ + "img/16-en_bannerbg.e9d766f3.png";